import React from "react";
import "./Resources.css";
import { Typography, Avatar, ListItem, List, Stack } from "@mui/joy";
import DescriptionIcon from "@mui/icons-material/Description";
import PeopleIcon from "@mui/icons-material/People";
import ThumbsUpDownIcon from '@mui/icons-material/ThumbsUpDown';
import BorderColorIcon from "@mui/icons-material/BorderColor";

const LearnTheProcess = () => {
  return (
    <Stack direction={"column"} padding={8} spacing={4}>
      <Stack direction={"column"} spacing={1}>
        <Typography level="h2" sx={{ textAlign: "center" }}>
          Learn the Process
        </Typography>
        <Typography level="body-md" sx={{ textAlign: "center" }}>
          Understanding how laws are made is the first step to effective
          activism.
        </Typography>
      </Stack>
      <List
        component={Stack}
        spacing={0}
        sx={{
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "flex-start",
          gap: '12px',
          alignItems: "stretch",
        }}
      >
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <DescriptionIcon />
          </Avatar>
          <Typography level="title-lg" sx={{ textAlign: "center" }}>
            Bill Introduction
          </Typography>
          <Typography level="body-md" sx={{ textAlign: "left" }}>
            A member of Congress (either the House or Senate) writes and
            introduces a bill, which is an idea for a new law.
            <ul>
              <li>The bill gets a number and a title.</li>
              <li>
                It is sent to a group of lawmakers (a committee) to study and
                possibly change.
              </li>
            </ul>
          </Typography>
        </ListItem>
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <PeopleIcon />
          </Avatar>
          <Typography level="title-lg" sx={{ textAlign: "center" }}>
            Committee Review and Hearings
          </Typography>
          <Typography level="body-md" sx={{ textAlign: "left" }}>
            The committee looks at the bill closely.
            <ul>
              <li>
                They hold meetings to gather information and listen to experts.
              </li>
              <li>They might make changes to improve it.</li>
              <li>
                They can vote to send it to the full House or Senate for more
                debate, or they can decide to reject it.
              </li>
            </ul>
          </Typography>
        </ListItem>
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <ThumbsUpDownIcon />
          </Avatar>
          <Typography
            level="title-lg"
            sx={{ textAlign: "center", width: "100%" }}
          >
            Floor Debate and Voting
          </Typography>
          <Typography level="body-md" sx={{ textAlign: "left", width: "100%" }}>
            If the committee approves the bill, the whole House or Senate
            discusses it.
            <ul>
              <li>Lawmakers debate the bill and suggest changes.</li>
              <li>They vote to approve or reject it.</li>
              <li>
                If it passes, it goes to the other chamber (House or Senate) to
                go through the same process.
              </li>
            </ul>
          </Typography>
        </ListItem>
        <ListItem sx={{ flexDirection: "column", flex: 1 }}>
          <Avatar color="primary">
            <BorderColorIcon />
          </Avatar>
          <Typography
            level="title-lg"
            sx={{ textAlign: "center", width: "100%" }}
          >
            Presidential Action
          </Typography>
          <Typography level="body-md" sx={{ textAlign: "left", width: "100%" }}>
            If both the House and Senate agree on the bill, they send it to the
            President.
            <ul>
              <li>The President can sign it into law.</li>
              <li>
                The President can veto (reject) it—but Congress can override the
                veto with a two-thirds vote.
              </li>
              <li>
                If the President does nothing for 10 days, the bill
                automatically becomes law if Congress is in session.
              </li>
            </ul>
          </Typography>
        </ListItem>
      </List>
    </Stack>
  );
};

export default LearnTheProcess;
